import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Grid, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import {
    useCreateContactField,
    useUpdateContactField,
} from '../../../../sic-lib/api/hooks/useContact';
import { ContactType } from '../../../../sic-lib/enums/ContactType';
import { Contact } from '../../../../sic-lib/types/Contact';
import {
    buildCreateContactField,
    buildUpdateContactField,
} from '../../../../sic-lib/types/ContactField';
import MenuSetContactTypeRaw from './MenuSetContactTypeRaw/MenuSetContactTypeRaw';

const useStyles = makeStyles()((theme: Theme) => ({
    btnType: {
        marginLeft: theme.spacing(1),
        color: theme.palette.btnDefault.main,
        '&:hover': {
            backgroundColor: theme.palette.btnDefault.light,
        },
    },
}));

interface Props {
    contact: Contact;
}

export default function MenuSetContactType({ contact }: Props) {
    const { classes } = useStyles();

    //fieldId 16 is contact Type
    const type = React.useMemo(() => {
        return contact.values.filter(itm => itm.fieldId === 16)[0] || null;
    }, [contact.values]);

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const [contactType, setContactType] = React.useState<string>('Set Type');
    const { mutate: updateContactField, error } = useUpdateContactField(contact.contactId);
    const { mutate: createContactField } = useCreateContactField(contact.contactId);

    React.useEffect(() => {
        if (type !== null) {
            const contactType = ContactType[type.value as keyof typeof ContactType].toString();
            setContactType(contactType);
        }
    }, [contact.contactId, type]);

    const handleChange = async (event: React.MouseEvent<HTMLElement>) => {
        handleClose();

        const { typeId } = event.currentTarget.dataset;

        if (typeId === undefined) {
            return;
        } else {
            const type = contact.values.find(itm => itm.fieldId === 16) || null;
            if (typeId === undefined) {
                return;
            } else if (type === null) {
                const updateType = buildCreateContactField({
                    fieldName: 'value',
                    fieldId: 16,
                    fieldType: 2,
                    leadId: contact.contactId,
                    value: typeId,
                    isVerified: false,
                });
                createContactField(updateType);
            } else {
                const updateType = buildUpdateContactField({
                    ...type,
                    ...{
                        fieldName: 'value',
                        value: ContactType[typeId as keyof typeof ContactType].toString(),
                    },
                });
                updateContactField(updateType);
            }
        }
    };

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Grid container flexDirection="row" alignItems="center" justifyContent="center">
            <Typography variant="caption">Contact Type:</Typography>
            <Tooltip title="Edit Contact Type" placement="top" disableInteractive>
                <Button
                    className={classes.btnType}
                    aria-haspopup="true"
                    aria-controls={`menu_contact_type_${contact.clientId}`}
                    aria-expanded={Boolean(anchorEl)}
                    endIcon={<ArrowDropDownIcon />}
                    onClick={handleOpen}
                >
                    {contactType === 'Undefined' ? 'Unknown' : contactType}
                </Button>
            </Tooltip>
            {Boolean(anchorEl) && (
                <MenuSetContactTypeRaw
                    typeId={type!.value}
                    menuId={`menu_contact_type_${contact.clientId}`}
                    anchorEl={anchorEl}
                    onChangeHandler={handleChange}
                    onCloseHandler={handleClose}
                />
            )}
        </Grid>
    );
}
